import React, {PureComponent} from 'react';
import styled from 'styled-components';

import Input from '../../components/Input';

import DeletableCard from './DeletableCard';
import ChipInput from '../../components/ChipInput';

class NotificationBuilder extends PureComponent {
  handleRemove = () => {
    const {notification, onRemove} = this.props;
    onRemove(notification);
  }

  setNotificationState = reducer => {
    const {notification, onChange} = this.props;

    onChange({
      ...notification,
      ...(typeof reducer === 'function' ? reducer(notification) : reducer)
    });
  }

  handleChangeType = e => {
    const {notification} = this.props;

    if (notification.type !== e.target.value) {
      this.setNotificationState({type: e.target.value});
    }
  }

  handleChangeUsers = users => {
    this.setNotificationState({users});
  }

  render() {
    const {notification, notifications, users, reviewersEnabled} = this.props;

    return (
      <DeletableCard
        focusable
        dialogTitle="Delete this notification?"
        dialogDescription="Are you sure you want to delete this notification? This cannot be undone."
        ok="Delete"
        onOk={this.handleRemove}>
        <NotificationForm>
          <Input
            id={`notification_${notification.id}_trigger`}
            label="Send a notification when..."
            type="select"
            disabled={notifications.length === (reviewersEnabled ? 4 : 2)}
            value={notification.type}
            onChange={this.handleChangeType}>
            <option value="sheetCompleteContacts">A sheet is completed</option>
            <option value="rowCompleteContacts">All of the questions are answered</option>
            {reviewersEnabled && (
              <>
                <option value="rowApprovedContacts">A submission is approved</option>
                <option value="rowRejectedContacts">A submission is rejected</option>
              </>
            )}
          </Input>
          <ChipInput
            id={`notification_${notification.id}_contacts`}
            label="Notification contacts"
            placeholder=""
            value={notification.users}
            suggestions={users}
            onChange={this.handleChangeUsers}
          />
        </NotificationForm>
      </DeletableCard>
    );
  }
}

const NotificationForm = styled.div`
  > * {
    margin-bottom: 1.5rem;

    :last-child {
      margin-bottom: 0;
    }
  }
`;

export default NotificationBuilder;
